import { c as _c } from "react/compiler-runtime";
export const GiftIcon = t0 => {
  const $ = _c(15);
  const {
    selected
  } = t0;
  const strokeColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.785645" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== strokeColor) {
    t3 = <path d="M27.9857 20V29H13.5857V20" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M29.7856 15.5H11.7856V20H29.7856V15.5Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M20.7856 29V15.5" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M20.7856 15.5H16.7356C16.1389 15.5 15.5666 15.2629 15.1446 14.841C14.7226 14.419 14.4856 13.8467 14.4856 13.25C14.4856 12.6533 14.7226 12.081 15.1446 11.659C15.5666 11.2371 16.1389 11 16.7356 11C19.8856 11 20.7856 15.5 20.7856 15.5Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M20.7856 15.5H24.8356C25.4324 15.5 26.0047 15.2629 26.4266 14.841C26.8486 14.419 27.0856 13.8467 27.0856 13.25C27.0856 12.6533 26.8486 12.081 26.4266 11.659C26.0047 11.2371 25.4324 11 24.8356 11C21.6856 11 20.7856 15.5 20.7856 15.5Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = strokeColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};